import Vue from 'vue';
import Translations from '../services/translations';
const $bus = new Vue();

export const GlobalMixin = {
    created() {
        this.$onInstance('update:lang', () => this.$forceUpdate());
        this.$onInstance('update:metric', () => this.$forceUpdate());
    },
    // mounted() {
    //     dd('MOUNTEDD');
    // },
    // updated() {
    //     dd('UPDATEE');
    // },
    // activated() {
    //     dd('ACTIVATED');
    // },
    // deactivated() {
    //     dd('DEACTIVATED');
    // },
    destroyed() {
        this.$emit('destroyed');
        //dd('DESTROYED');
    },
    methods: {
        $onInstance(key, callback) {
            $bus.$on(key, callback);
            this.$on('destroyed', () => {
                $bus.$off(key, callback);
            });
        },
        $onceOutInstance(event, callbackOK, callbackKO, callbackEND, time) {
            let out = setTimeout(() => {
                out = null;
                if (callbackKO) callbackKO();
                if (callbackEND) callbackEND();
            }, time);
            $bus.$once(event, (data) => {
                if (out) {
                    clearTimeout(out);
                    if (callbackOK) callbackOK(data);
                    if (callbackEND) callbackEND();
                }
            });
        },
        $emitInstance(key, ...args) {
            $bus.$emit(key, ...args);
        },
        $changeMetric(metric) {
            if (Vue.prototype.$dicc.typeMetrics[metric]) {
                Vue.prototype.$metric = metric;
                this.$emitInstance('update:metric');
            }
        },
        $changeLanguage(lang) {
            lang = lang || localStorage.getItem('lang') || navigator.language.split(/-|_/)[0];
            if (!this.$config.AVAILABLE_LANGS[lang]) lang = this.$config.DEFAULT_LANG;
            if (Vue.prototype.$lang === lang) return;
            localStorage.setItem('lang', lang);
            Vue.prototype.$lang = lang;
            Vue.prototype.$dicc = new Translations(this.$config.DEFAULT_LANG, lang).translation;
            this.$emitInstance('update:lang');
        },
        $castMetric(val) {
            if (Vue.prototype.$metric.toUpperCase() != 'F') return val;
            else return Math.round(((val * 9) / 5 + 32) * 100) / 100;
        },
    },
};
